var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 18.8242C4.02746 18.3489 4.17158 17.8669 4.45273 17.4151L5.95545 15H18.0405L19.5418 17.4171C20.783 19.4155 19.3459 22 16.9934 22H6.99989C5.30552 22 4.0862 20.6595 4 19.163V18.8242Z",
    fill: "#A461D8",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 7H16C16.5523 7 17 7.44772 17 8C17 8.55228 16.5523 9 16 9H15.9999V11.4294C15.9999 11.6159 16.052 11.7987 16.1504 11.9571L19.5418 17.4171C20.783 19.4155 19.3459 22 16.9934 22H6.99989C4.64628 22 3.20931 19.4134 4.45273 17.4151L7.84896 11.9569C7.94761 11.7983 7.9999 11.6153 7.9999 11.4286V9C7.44766 8.99995 6.99999 8.55226 6.99999 8C6.99999 7.44774 7.44766 7.00005 7.9999 7C7.99993 7 7.99996 7 7.99999 7H8.9999H14.9999H15.9999ZM9.9999 9V11.4286C9.9999 11.9888 9.84304 12.5378 9.54707 13.0135L6.15084 18.4717C5.73637 19.1378 6.21536 20 6.99989 20H16.9934C17.7775 20 18.2566 19.1385 17.8428 18.4724L14.4515 13.0123C14.1563 12.5371 13.9999 11.9888 13.9999 11.4294V9H9.9999Z",
    fill: "#A461D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4C14.5523 4 15 3.55228 15 3C15 2.44772 14.5523 2 14 2C13.4477 2 13 2.44772 13 3C13 3.55228 13.4477 4 14 4ZM10 5C10.5523 5 11 4.55228 11 4C11 3.44772 10.5523 3 10 3C9.44772 3 9 3.44772 9 4C9 4.55228 9.44772 5 10 5Z",
    fill: "#A461D8",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabTest);
export default __webpack_public_path__ + "static/media/lab-test.463109e876a14459b17c9430fed1effc.svg";
export { ForwardRef as ReactComponent };